import { Notation } from '@teetsh/app/src/types/notationSystem';
import { getNotationFromValue } from './getNotationFromValue';

export const getClosestValueFromNotationSystem = (
  value: number,
  values: Notation[],
) => {
  const result = (values || []).find(
    v => v.label === getNotationFromValue(value, values),
  );
  return result ? result.value : 0;
};
